// Collection Product Cards functionality - matching home page behavior
document.addEventListener('DOMContentLoaded', function() {
  // Handle variant selection
  const variantSelects = document.querySelectorAll('.collection-variant-select');
  
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.dataset.productId;
      const selectedOption = this.options[this.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const image = selectedOption.dataset.image;
      
      const card = this.closest('.collection-product-card');
      
      // Update price
      const priceElement = card.querySelector('.collection-product-price');
      if (priceElement && price) {
        // Format price using Shopify's money format with active currency
        const activeCurrency = window.Shopify?.currency?.active || 'USD';
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: activeCurrency,
          minimumFractionDigits: 2
        }).format(price / 100);
        priceElement.textContent = formattedPrice;
        priceElement.dataset.price = price;
      }
      
      // Update image if variant has one
      const productImage = card.querySelector('.collection-product-image');
      if (productImage && image) {
        productImage.src = image;
      }
      
      // Update add to cart button variant ID and availability state
      const addToCartBtn = card.querySelector('.collection-add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = variantId;

        // Check if variant is available
        const isAvailable = selectedOption.dataset.available === 'true';
        if (isAvailable) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('sold-out');
          addToCartBtn.textContent = 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('sold-out');
          addToCartBtn.textContent = 'Sold Out';
        }

        // Clear any previous error messages
        const existingError = card.querySelector('.add-to-cart-error');
        if (existingError) {
          existingError.remove();
        }
      }
    });
  });
  
  // Handle add to cart functionality
  const addToCartButtons = document.querySelectorAll('.collection-add-to-cart-btn');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = this.dataset.variantId;
      const productId = this.dataset.productId;
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }
      
      // Add loading state
      this.classList.add('loading');
      this.disabled = true;
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Remove loading state
        this.classList.remove('loading');
        this.disabled = false;
        
        if (data.status && data.status === 422) {
          // Handle error (out of stock, etc.) with inline message instead of alert
          const card = this.closest('.collection-product-card');

          // Remove any existing error message
          const existingError = card.querySelector('.add-to-cart-error');
          if (existingError) {
            existingError.remove();
          }

          // Create inline error message
          const errorDiv = document.createElement('div');
          errorDiv.className = 'add-to-cart-error';
          errorDiv.style.cssText = 'color: #e74c3c; font-size: 12px; margin-top: 8px; text-align: center; padding: 6px; background: #fdf2f2; border-radius: 4px;';
          errorDiv.textContent = data.description || 'This item is sold out';

          // Insert error after button
          this.parentNode.insertBefore(errorDiv, this.nextSibling);

          // Update button to show sold out state
          this.classList.add('sold-out');
          this.textContent = 'Sold Out';
          this.disabled = true;

          // Auto-remove error message after 5 seconds
          setTimeout(() => {
            if (errorDiv.parentNode) {
              errorDiv.remove();
            }
          }, 5000);
        } else {
          // Success - update cart
          this.textContent = 'Added!';
          setTimeout(() => {
            this.textContent = 'Add to Cart';
          }, 2000);
          
          // Trigger cart update events
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'collection-product-card', productVariantId: variantId});
          }
          
          // Update sticky cart count
          if (typeof window.updateStickyCart === 'function') {
            window.updateStickyCart();
          }

          // Update all cart count badges
          updateAllCartCounts();

          // Check add to cart behavior setting
          const addToCartBehavior = window.themeSettings?.addToCartBehavior || 'notification';

          if (addToCartBehavior === 'drawer') {
            // Auto-open cart drawer if it exists
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              setTimeout(() => {
                cartDrawer.open();
              }, 100);
            }
          }
          // Success notification is already shown via button text change "Added!"
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.classList.remove('loading');
        this.disabled = false;

        // Show inline error instead of alert
        const card = this.closest('.collection-product-card');
        const existingError = card.querySelector('.add-to-cart-error');
        if (existingError) {
          existingError.remove();
        }

        const errorDiv = document.createElement('div');
        errorDiv.className = 'add-to-cart-error';
        errorDiv.style.cssText = 'color: #e74c3c; font-size: 12px; margin-top: 8px; text-align: center; padding: 6px; background: #fdf2f2; border-radius: 4px;';
        errorDiv.textContent = 'Error adding item. Please try again.';
        this.parentNode.insertBefore(errorDiv, this.nextSibling);

        setTimeout(() => {
          if (errorDiv.parentNode) {
            errorDiv.remove();
          }
        }, 5000);
      });
    });
  });
  
  // Prevent clicks on variant selectors from triggering product link
  const variantSelectors = document.querySelectorAll('.collection-variant-selector');
  variantSelectors.forEach(selector => {
    selector.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
  
  // Prevent clicks on buttons from triggering product link
  const buttons = document.querySelectorAll('.collection-add-to-cart-btn');
  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
});

// Reinitialize when new products are loaded via infinite scroll
document.addEventListener('shopify:section:load', function() {
  // Re-run the initialization for newly loaded content
  setTimeout(() => {
    const event = new Event('DOMContentLoaded');
    document.dispatchEvent(event);
  }, 100);
});

// Function to update all cart count badges across the site
function updateAllCartCounts() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const count = cart.item_count;

      // Update TCG header cart badge
      const tcgCartBadge = document.querySelector('#cart-icon .tcg-badge');
      if (tcgCartBadge) {
        tcgCartBadge.textContent = count;
        // Add animation
        tcgCartBadge.classList.add('cart-updated');
        setTimeout(() => tcgCartBadge.classList.remove('cart-updated'), 300);
      }

      // Update standard cart icon bubble (Dawn theme style)
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        const countElement = bubble.querySelector('[aria-hidden="true"]') || bubble.querySelector('span:not(.visually-hidden)');
        if (countElement) {
          countElement.textContent = count;
        }
        // Show/hide based on count
        bubble.style.display = count > 0 ? '' : 'none';
        // Add animation
        bubble.classList.add('cart-updated');
        setTimeout(() => bubble.classList.remove('cart-updated'), 300);
      });

      // Update any elements with data-cart-count attribute
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
        el.setAttribute('data-cart-count', count);
      });

      // Update .cart-count elements
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
      });

      // Update sticky cart count
      const stickyCartCount = document.getElementById('sticky-cart-count');
      if (stickyCartCount) {
        stickyCartCount.textContent = count;
      }

      // Update mobile header cart count (the count is in a span inside)
      document.querySelectorAll('.mobile-header__cart-count span').forEach(el => {
        el.textContent = count;
      });
      // Also update if the text is directly in the element
      document.querySelectorAll('.mobile-header__cart-count').forEach(el => {
        if (el.childElementCount === 0) {
          el.textContent = count;
        }
      });

      // Trigger custom event for any other listeners
      document.dispatchEvent(new CustomEvent('cart:count-updated', {
        detail: { count: count, cart: cart }
      }));
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Make function globally available
window.updateAllCartCounts = updateAllCartCounts;
